import { render } from "./AgentsDashboard.vue?vue&type=template&id=fe54f9a4&scoped=true&lang=pug"
import script from "./AgentsDashboard.vue?vue&type=script&lang=js"
export * from "./AgentsDashboard.vue?vue&type=script&lang=js"

import "./AgentsDashboard.vue?vue&type=style&index=0&id=fe54f9a4&lang=scss&scoped=true"
import "./AgentsDashboard.vue?vue&type=style&index=1&id=fe54f9a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe54f9a4"]])

export default __exports__